import { CoinHistoryPage } from './CoinHistoryPage'
import { withCoinHistoryPage } from './withCoinHistoryPage'

const ConnectedCoinHistoryPage = withCoinHistoryPage(CoinHistoryPage)

export { ConnectedCoinHistoryPage as CoinHistoryPage }
